// Node modules
import { IntroOutroViewBehavior } from "@quest/murka-games-behavior-panther/dist/";

export class IntroOutroViewGame extends IntroOutroViewBehavior {
  // Overrided to remove code
  protected changeIntroMeterParent(): void {
    //
  }

}
